import { globalStateCTX } from '../../../GlobalState/GlobalState';
import { useNonce } from '../../../Utils/hooks';
import NumberFormater from '../../NumberFormater/NumberFormater';
import KpiCard, { KPISize, KPIStatus } from '../../KPIs/KPICard/KpiCard';
import React from 'react';
import { statisticsApi } from '../../../Http/Http';
import { useTranslation } from 'react-i18next';
import { FilterValuesType } from '../../../FiltersProvider/FiltersProvider';

interface Props {
  filterValues?: FilterValuesType;
  propertyId?: number;
}

const PlotAreaKpi: React.FC<Props> = (props) => {
  const { t } = useTranslation(['contracts', 'common']);

  const { handleHttpErrors } = React.useContext(globalStateCTX);

  const [areaStatistics, setAreaStatistics] = React.useState<number>();
  const [status, setStatus] = React.useState<KPIStatus>(KPIStatus.Loading);
  const [shouldReload, reload] = useNonce();

  React.useEffect(() => {
    const abortController = new AbortController();

    const load = async () => {
      try {
        setStatus(KPIStatus.Loading);
        const { data } = await statisticsApi.statisticsResourceGetPlotArea(
          {
            ...props.filterValues,
            propertyId: props.propertyId
          },
          {
            signal: abortController.signal
          }
        );

        setAreaStatistics(data.plotArea);
        setStatus(KPIStatus.None);
      } catch (error) {
        handleHttpErrors(error) && setStatus(KPIStatus.LoadError);
      }
    };
    load();
    return () => abortController.abort();
  }, [props.filterValues, props.propertyId, handleHttpErrors, shouldReload]);

  return (
    <KpiCard
      title={t('contracts:landArea')}
      value={<NumberFormater value={areaStatistics} />}
      valueSuffix={t('common:sqm')}
      valueAs="h5"
      status={status}
      retry={reload}
      size={KPISize.small}
    />
  );
};

export default PlotAreaKpi;
